<script setup lang="ts">
/**
 * Default Layout
 * --------------------------------------------------------------------------------------------------
 * Layout used for most pages. Adds basic UI like Logo, Progress Dots, Footer
 */

const {
    isEnabled: isFooterEnabled,
} = useFooterState();

const { isFeatureEnabled } = useFeatureFlags();

provide('isSubFlow', false);
</script>

<template>
    <div>
        <TheBaseLayout>
            <div
                class="
                    grid
                    h-full
                    grid-rows-[auto_min-content]
                    bg-background-1
                "
            >
                <div class="relative">
                    <slot name="logo">
                        <TheLogo />
                    </slot>

                    <slot name="progressDots">
                        <div class="absolute top-8 right-container-gap z-30 flex items-center space-x-4 sm:top-11 md:top-[25px]">
                            <TheProgressDots />
                            <TheCartNav />
                            <TheAuthNav v-if="isFeatureEnabled('login')" />
                            <TheFlowCloseNav />
                        </div>
                    </slot>

                    <NuxtPage />
                </div>

                <div :class="isFooterEnabled ? 'h-[68px] md:h-[76px]' : 'h-0'">
                    <TheFooter />
                </div>
            </div>
        </TheBaseLayout>
    </div>
</template>
